module.exports = __webpack_public_path__ + "img/building.9342880d.png";